const VIEWS = {
  MENU: { key: "MENU", title: "Site Data", subTitle: "Manage site data." },
  GUARDIAN_IMPORT_ISSUE_REPORT: { key: "GUARDIAN_IMPORT_ISSUE_REPORT", title: "Guardian Import Issues", subTitle: "Guardians that cannot be imported." },
  LAST_IMPORT_REPORT: { key: "LAST_IMPORT_REPORT", title: "Last Import Report", subTitle: "View the last import details." },
  META: { key: "META", title: "Meta Details", subTitle: "View site data meta details." },
};

export { VIEWS }
